<div class="table-scroll-container">
  <table mat-table [dataSource]="isLoading() ? loadingPlaceholderRows() : rows()" id="my-table" matSort (matSortChange)="onSortChanged($event)">
    <ng-container matColumnDef="itemId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div (click)="$event.stopPropagation()">
          <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.filterMenu" [matMenuTriggerData]="{ caller: callers()['itemId'], integerOnly: true }" type="button">
            {{ 'dataManagement.import.id' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(callers()['itemId'])">filter_alt</mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *appSingleBlocSkeleton="isLoading(); width: '40%'">{{ element.displayId }}</ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="version">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'dataManagement.import.version' | transloco }}
      </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *appSingleBlocSkeleton="isLoading(); width: '30%'">{{ element.version }}</ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="exportingOrganization">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div (click)="$event.stopPropagation()">
          <button
            mat-button
            class="filter-button"
            [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
            [matMenuTriggerData]="{ caller: callers()['exportingOrganization'], categories: organizationOptions() }"
            type="button">
            {{ 'dataManagement.import.exportingOrganization' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(callers()['exportingOrganization'])">filter_alt</mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *appSingleBlocSkeleton="isLoading(); width: '80%'">{{ isChange() ? (element.organizationId | lookupName: organizationNameById()) : element.exportingOrganization.name }}</ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="packagingTypeName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div (click)="$event.stopPropagation()">
          <button
            mat-button
            class="filter-button"
            [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
            [matMenuTriggerData]="{ caller: callers()['packagingTypeName'], categories: packagingTypeOptions }"
            type="button">
            {{ 'packagingUnit.packagingUnitType' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(callers()['packagingTypeName'])">filter_alt</mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *appSingleBlocSkeleton="isLoading(); width: '70%'">{{ element.packagingTypeName }}</ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="brandName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div (click)="$event.stopPropagation()">
          <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.filterMenu" [matMenuTriggerData]="{ caller: callers()['brandName'] }" type="button">
            {{ 'packagingUnit.fields.brandName' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(callers()['brandName'])">filter_alt</mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *appSingleBlocSkeleton="isLoading(); width: '70%'">{{ element.brandName }}</ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="productName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div (click)="$event.stopPropagation()">
          <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.filterMenu" [matMenuTriggerData]="{ caller: callers()['productName'] }" type="button">
            {{ 'packagingUnit.fields.productName' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(callers()['productName'])">filter_alt</mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *appSingleBlocSkeleton="isLoading(); width: '80%'">{{ element.productName }}</ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="packagingComponentCategoryName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div (click)="$event.stopPropagation()">
          <button
            mat-button
            class="filter-button"
            [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
            [matMenuTriggerData]="{ caller: callers()['packagingComponentCategoryName'], categories: componentCategoryOptions }"
            type="button">
            {{ 'component.componentType' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(callers()['packagingComponentCategoryName'])">filter_alt</mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *appSingleBlocSkeleton="isLoading(); width: '70%'">{{ element.packagingComponentCategoryName }}</ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="packagingComponentSubtypeName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div (click)="$event.stopPropagation()">
          <button
            mat-button
            class="filter-button"
            [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
            [matMenuTriggerData]="{ caller: callers()['packagingComponentSubtypeName'], categories: componentSubtypeOptions }"
            type="button">
            {{ 'component.componentSpecificType' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(callers()['packagingComponentSubtypeName'])">filter_alt</mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *appSingleBlocSkeleton="isLoading(); width: '70%'">{{ element.packagingComponentSubtypeName }}</ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="articleName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div (click)="$event.stopPropagation()">
          <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.filterMenu" [matMenuTriggerData]="{ caller: callers()['articleName'] }" type="button">
            {{ 'component.fields.articleName' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(callers()['articleName'])">filter_alt</mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *appSingleBlocSkeleton="isLoading(); width: '80%'">{{ element.articleName }}</ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="articleNumber">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div (click)="$event.stopPropagation()">
          <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.filterMenu" [matMenuTriggerData]="{ caller: callers()['articleNumber'] }" type="button">
            {{ 'component.fields.articleNumber' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(callers()['articleNumber'])">filter_alt</mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *appSingleBlocSkeleton="isLoading(); width: '50%'">{{ element.articleNumber }}</ng-container>
      </td>
    </ng-container>

    <ng-container *ngIf="!isChange()" matColumnDef="timestamp">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'component.fields.exportTimestamp' | transloco }}
      </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *appSingleBlocSkeleton="isLoading(); width: '70%'">{{ element.exportTimestamp | date: 'short' }}</ng-container>
      </td>
    </ng-container>

    <ng-container *ngIf="isChange()" matColumnDef="timestamp">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'component.fields.lastModificationTimestamp' | transloco }}
      </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *appSingleBlocSkeleton="isLoading(); width: '70%'">{{ element.lastModificationTimestamp | date: 'short' }}</ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>
        <span class="header-text">{{ 'dataManagement.actions' | transloco }}</span>
      </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *appSingleBlocSkeleton="isLoading(); width: '48px'; height: '24px'">
          <button
            mat-icon-button
            type="button"
            (click)="navigateToCandidate(element)"
            matTooltip="{{
              (isPackagingSystem
                ? 'packagingSystem.viewPackagingSystem'
                : isPackagingUnit
                  ? 'packagingUnit.viewPackagingUnit'
                  : isComponent
                    ? 'component.viewComponent'
                    : isMaterial
                      ? 'material.viewMaterial'
                      : ''
              ) | transloco
            }}"
            *ngIf="!isChange(); else viewChanges">
            <mat-icon>preview</mat-icon>
          </button>
          <ng-template #viewChanges>
            <button
              mat-icon-button
              type="button"
              (click)="navigateToCandidate(element, true)"
              matTooltip="{{
                (isPackagingSystem
                  ? 'packagingSystem.viewPackagingSystemBeforeChange'
                  : isPackagingUnit
                    ? 'packagingUnit.viewPackagingUnitBeforeChange'
                    : isComponent
                      ? 'component.viewComponentBeforeChange'
                      : isMaterial
                        ? 'material.viewMaterialBeforeChange'
                        : ''
                ) | transloco
              }}">
              <mat-icon>access_time</mat-icon>
            </button>
            <button
              mat-icon-button
              type="button"
              (click)="navigateToCandidate(element, false)"
              matTooltip="{{
                (isPackagingSystem
                  ? 'packagingSystem.viewPackagingSystemAfterChange'
                  : isPackagingUnit
                    ? 'packagingUnit.viewPackagingUnitAfterChange'
                    : isComponent
                      ? 'component.viewComponentAfterChange'
                      : isMaterial
                        ? 'material.viewMaterialAfterChange'
                        : ''
                ) | transloco
              }}">
              <mat-icon>access_time_filled</mat-icon>
            </button>
          </ng-template>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <div (click)="$event.stopPropagation()">
          <button mat-button class="filter-button" (click)="selectAll()" type="button">
            <div>
              {{ (isAllCandidateIdsSelected ? 'common.buttons.selectNone' : 'common.buttons.selectAll') | transloco }} <br />
              ({{ selectedCandidateIds.size }} {{ 'common.text.selected' | transloco }})
            </div>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *appSingleBlocSkeleton="isLoading(); width: '24px'; height: '24px'">
          <mat-checkbox [checked]="isSelectedCandidate(element)" (change)="setSelectedCandidates($event.checked, element)" class="margin-checkbox"> </mat-checkbox>
        </ng-container>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" [class.notificationBackground]="row.hasNotification"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">
        {{ (filteredColumns.length === 0 ? 'dataManagement.noData' : 'dataManagement.noFilteredResults') | transloco }}
      </td>
    </tr>
  </table>
</div>
<mat-paginator
  class="import-html-paginator"
  [pageSizeOptions]="pageSizeOptions"
  [pageSize]="currentPageSize()"
  [length]="totalItemCount"
  [pageIndex]="currentPageIndex"
  showFirstLastButtons
  aria-label="Select page"
  (page)="onPageChanged($event)" />

<app-filter-menu #filterComponent="columnFilterComponent" [dataSource]="paginationDataSource!"></app-filter-menu>
